import { SystemStyleObject } from '@chakra-ui/react';

const avatarSimpleBgSx: SystemStyleObject = {
  position: 'absolute',
  top: 0,
  w: 'full',
  h: 'full',
  zIndex: -1,
  opacity: 0.8,
};

const bgImageContainerSx: SystemStyleObject = {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
};

const bgImageSx: SystemStyleObject = {
  width: '100%',
  height: '100%',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  transform: 'scale(1.3)',
};

export { avatarSimpleBgSx, bgImageContainerSx, bgImageSx };
